import { useGlobalAppState } from '@order/GlobalAppState';

export const useLastInteractedStoreMachine = () => {
  const { lastInteractedStoreMachineRef } = useGlobalAppState();

  return lastInteractedStoreMachineRef;
};
